import moment from 'moment'
import { z } from 'zod'
import { t } from '@/I18n'
import { DateFormat } from '@/interfaces/Date.interfaces'

export const notEmptyString = z.string().trim().min(1)

export const notEmptyValue = z.unknown().refine((value) => value !== null && value !== undefined && value !== '', {
  params: { i18n: 'zod.errors.mandatory' },
})

export const validDate = (format: DateFormat) =>
  notEmptyString.refine((value) => moment(value, format, true).isValid(), {
    params: { i18n: { key: 'zod.errors.invalid_date_format', values: { format } } },
  })

export const validDateFr = validDate(DateFormat.FR)

export const numericString = z.string().refine((value) => /^\d*$/.test(value), {
  params: { i18n: 'zod.errors.numeric' },
})

export const numberBetween = (min: number, max: number, errorMessage: string = t('zod.errors.mandatory')) =>
  z.preprocess(
    (value) => (value === '' ? undefined : value),
    z
      .number({ required_error: t('zod.errors.mandatory') })
      .min(min)
      .max(max, { message: errorMessage })
  )
